import { call, put, takeLatest } from 'redux-saga/effects';
import { normalize } from 'normalizr';

import { currentCompany, entity, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';
import { company as companySchema } from '../../../schema';

export function* update({ payload: { id } }) {
  try {
    const { data: { company } } = yield call(dataProvider.updateOnly, `Companies/${id}/image/delete`);

    const normalizeData = normalize([{ ...company, level: company.companyLevel }], [companySchema]);
    yield put({ type: entity.add, payload: normalizeData.entities });
    yield put({ type: currentCompany.info.deleteImage.end, payload: {} });
  } catch (e) {
    yield put({ type: currentCompany.info.deleteImage.error });
    yield put({ type: notification.add, payload: { error: e.message } });
  }
}

export default function* deleteCompanyImageSaga() {
  yield takeLatest(currentCompany.info.deleteImage.start, update);
}
